import { render } from "./BSModal.vue?vue&type=template&id=341650e6"
import script from "./BSModal.vue?vue&type=script&lang=js"
export * from "./BSModal.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Dev\\devine-mot\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__